// extracted by mini-css-extract-plugin
module.exports = {"control":"Checkout_control__3DPMV","wrapper":"Checkout_wrapper__2cXoW","confirm":"Checkout_confirm__2P1Qh","price":"Checkout_price__OIJcK"};